import gql from 'graphql-tag';

const GET_SALESFORCE_OPPORTUNITY_PROPOSAL_FILENAME = gql`
  query GetSalesforceOpportunityProposalFilename($salesforceOpportunityId: String!) {
    getSalesforceOpportunityProposalFilename(
      salesforceOpportunityId: $salesforceOpportunityId
    )
  }
`;

export default GET_SALESFORCE_OPPORTUNITY_PROPOSAL_FILENAME;
